import { hits } from "instantsearch.js/es/widgets";
import slugify from "@sindresorhus/slugify";

const itemContainer = document.getElementById("hits");
const itemsWidget =
  itemContainer &&
  hits({
    container: "#hits",
    templates: {
      item(hit, { html, components }) {
        // const comingSoonDiv = hit.isComingSoon
        //   ? html`<div>
        //       <div
        //         class="items-center text-gray-600 bg-gray-50 badge badge-md rounded-md py-1 px-3 group-hover:text-gray-600"
        //       >
        //         Coming Soon
        //       </div>
        //     </div>`
        //   : html``;

        const comingSoonDiv = hit.isComingSoon
          ? html`<div
              class="absolute w-full h-full inset-0 opacity-0 rounded-2xl duration-500 bg-blue-600 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 group-hover:ease-in-out group-hover:block"
            >
              <div
                class="flex flex-col items-start justify-center h-full pl-6 pt-8 duration-300 ease-in-out delay-100 group-hover:duration-500 group-hover:pt-0"
              >
                <p
                  class="p3 text-white mb-3"
                  style="font-size:15px !important;"
                >
                  This connector will be released soon. Learn more about it from
                  our team.
                </p>
                <div
                  class="text-cyan-500 cursor-pointer"
                  style="font-size:15px;font-weight:600 !important;"
                >
                  Talk to us
                  <img
                    src="https://website-assets.atlan.com/img/arrow-right-cyan.svg"
                    alt="cyan arrow"
                    style="width:12px;"
                    class="ml-1"
                  />
                </div>
              </div>
            </div>`
          : html``;

        const underConsiderationDiv = hit.isUnderConsideration
          ? html`<div
              class="absolute w-full h-full inset-0 opacity-0 rounded-2xl duration-500 bg-blue-600 pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 group-hover:ease-in-out group-hover:block"
            >
              <div
                class="flex flex-col items-start justify-center h-full pl-6 pt-8 duration-300 ease-in-out delay-100 group-hover:duration-500 group-hover:pt-0"
              >
                <p
                  class="p3 text-white mb-3"
                  style="font-size:15px !important;"
                >
                  Is this connector important to you? <br />
                  Let's build it together.
                </p>
                <div
                  class="text-cyan-500 cursor-pointer"
                  style="font-size:15px;font-weight:600 !important;"
                >
                  Talk to us
                  <img
                    src="https://website-assets.atlan.com/img/arrow-right-cyan.svg"
                    alt="cyan arrow"
                    style="width:12px;"
                    class="ml-1"
                  />
                </div>
              </div>
            </div>`
          : html``;

        const comingSoonTag = hit.isComingSoon
          ? html`<div>
              <div
                class="items-center text-blue-500 bg-gray-50 badge badge-md rounded-md py-1 px-3"
                style="background-color:background: #F5F5FF;"
              >
                Coming Soon
              </div>
            </div>`
          : html``;

        const underConsiderationTag = hit.isUnderConsideration
          ? html`<div>
              <div
                class="items-center text-gray-500 bg-gray-50 badge badge-md rounded-md py-1 px-3 bg-gray-50"
              >
                Under Consideration
              </div>
            </div>`
          : html``;

        const makeSlug = (text) => {
          return slugify(text || "", {
            customReplacements: [["'", ""]],
          });
        };

        return html`
          <a
            class="flex flex-col items-start pl-6 pr-6 py-6 border rounded-2xl relative h-full min-h-[138px] ${hit.parentClass} connector-card"
            href="${hit.link || `/forms/get-started/?name=${hit.name}`}"
            target="${hit.link ? "_blank" : ""}"
            id="connector_${hit.objectID}"
            style="border-width:1px"
            data-connector-title="${hit.name}"
            data-category-type="${hit.isComingSoon
              ? "comingSoon"
              : hit.isUnderConsideration
              ? "underConsideration"
              : "live"}"
            data-filter-item="${makeSlug(hit.tagType) || "all"}"
          >
            ${underConsiderationDiv} ${comingSoonDiv}

            <div class="flex flex-col h-full justify-between w-full gap-2">
              <div class="flex items-start justify-between flex-1">
                <div class="mb-2 h-15 flex-1">
                  <div class="max-h-[50px]">
                    <img
                      src="${hit.logo}"
                      alt="altText"
                      class="${hit.iconClass ? hit.iconClass : "w-16 h-full"}"
                    />
                  </div>
                </div>
                <div
                  class="badge badge-md rounded-md py-1 px-3 !hidden group-hover:!block ${hit.isComingSoon ||
                  hit.isUnderConsideration
                    ? "group-hover:!hidden"
                    : ""}"
                  style="background-color: ${hit.tagBg}"
                >
                  <span style="color: ${hit.tagTextColor}">${hit.tagName}</span>
                </div>
                ${comingSoonTag} ${underConsiderationTag}
              </div>
              <div>
                <div class="flex items-start justify-between">
                  <h6
                    class="font-bold text-lg text-gray-600 p2 connector-title"
                    style="font-weight:900"
                  >
                    ${components.Highlight({ hit: hit, attribute: "name" })}
                  </h6>
                  <img
                    class="group-hover:!block !hidden ${hit.isComingSoon ||
                    hit.isUnderConsideration
                      ? "group-hover:!hidden"
                      : ""}"
                    src="https://website-assets.atlan.com/img/chevron-right-primary.svg"
                    alt="icon"
                  />
                </div>
              </div>
            </div>
          </a>
        `;
      },
      empty() {
        return `
  <div class="hits-empty-state">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="138"
      height="138"
      class="hits-empty-state-image"
    >
      <defs>
        <linearGradient id="c" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stop-color="#F5F5FA" />
          <stop offset="100%" stop-color="#FFF" />
        </linearGradient>
        <path
          id="b"
          d="M68.71 114.25a45.54 45.54 0 1 1 0-91.08 45.54 45.54 0 0 1 0 91.08z"
        />
        <filter
          id="a"
          width="140.6%"
          height="140.6%"
          x="-20.3%"
          y="-15.9%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="5.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0.145098039 0 0 0 0 0.17254902 0 0 0 0 0.380392157 0 0 0 0.15 0"
          />
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
          <feGaussianBlur
            in="shadowOffsetOuter2"
            result="shadowBlurOuter2"
            stdDeviation="1.5"
          />
          <feColorMatrix
            in="shadowBlurOuter2"
            result="shadowMatrixOuter2"
            values="0 0 0 0 0.364705882 0 0 0 0 0.392156863 0 0 0 0 0.580392157 0 0 0 0.2 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="shadowMatrixOuter2" />
          </feMerge>
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <circle
          cx="68.85"
          cy="68.85"
          r="68.85"
          fill="#5468FF"
          opacity=".07"
        />
        <circle
          cx="68.85"
          cy="68.85"
          r="52.95"
          fill="#5468FF"
          opacity=".08"
        />
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <use fill="url(#c)" xlink:href="#b" />
        <path
          d="M76.01 75.44c5-5 5.03-13.06.07-18.01a12.73 12.73 0 0 0-18 .07c-5 4.99-5.03 13.05-.07 18a12.73 12.73 0 0 0 18-.06zm2.5 2.5a16.28 16.28 0 0 1-23.02.09A16.29 16.29 0 0 1 55.57 55a16.28 16.28 0 0 1 23.03-.1 16.28 16.28 0 0 1-.08 23.04zm1.08-1.08l-2.15 2.16 8.6 8.6 2.16-2.15-8.6-8.6z"
          fill="#5369FF"
        />
      </g>
    </svg>

    <p class="hits-empty-state-title">
      Can't find the tool in your stack?
    </p>
    <p class="hits-empty-state-description">
      Let us know and we'll build it together.
    </p>
    <a  class="btn btn-primary mt-5 btn-sm send-ga-event p3 block" 
        data-modal="request-integration-modal" 
        id="request-connector-btn-top-fold" 
        style="border-radius:13px !important;"
        >
    Request connector</a>
  </div>
`;
      },
    },
  });

export const items = itemsWidget;

//  data-modal="${hit.isComingSoon
//               ? "coming-soon-modal"
//               : hit.isUnderConsideration
//               ? "under-consideration-modal"
//               : hit.link
//               ? null
//               : "modal-live-connector"}"
